import { useTranslation } from 'next-i18next/pages';
import type { ReactNode } from 'react';

import useCurrentLang from '@/hooks/apps/useCurrentLang';

import {
  COMPANY_ADDRESS,
  COMPANY_LOCATION_COORDINATES,
} from '@/data/shared/companyLocation';

import AniSlideUp from '@/components/shared/animations/basic/AniSlideUp';

import Area from '../../layouts/shared/Area';
import { CustomGoogleMap } from '../../ui/maps/googleMap/CustomGoogleMap';
import SectionTitle from '../../ui/title/SectionTitle';

// 지도 데이터
const DUMMY_MAP_DATA = [
  {
    title: 'Deeply',
    add_data: {
      address: COMPANY_LOCATION_COORDINATES,
    },
  },
];

type Props = {
  phoneNumber: ReactNode;
};

export default function AboutMapSection({ phoneNumber }: Props) {
  const { t } = useTranslation('common');

  const MarkerData = DUMMY_MAP_DATA.map((item) => ({
    title: item.title,
    logo: {
      src: '/images/apps/about/MapLabelMarker_icon_horizontal_white.svg',
      pcSize: { width: 150, height: 50 },
      mobileSize: { width: 150, height: 50 },
    },
    lat: item.add_data.address.lat,
    lng: item.add_data.address.lng,
  }));

  const markerClickHandler = (title: string) => {
    console.log(`${title} Marker Clicked`);
  };

  const currentLang = useCurrentLang();

  return (
    <section className="bg-apps-brandGrayBlack py-[clamp(100px,10.417vw,200px)]">
      <Area>
        <SectionTitle title={t('오시는 길')} color="lighter" />
        <div className="mt-[40px] lg:mt-[60px] lg:flex lg:items-center lg:gap-[26px]">
          <h3 className="text-[22px] font-bold leading-[160%] tracking-[-0.44px] text-apps-brandGrayWhite lg:text-[24px] lg:leading-[140%] lg:tracking-[-0.56px] 2xl:text-[28px] 2xl:leading-[140%] 2xl:tracking-[-0.56px]">
            {t('디플리 본사')}
          </h3>
          {/* margin: 8px 0 의 좌우 0 은 reset 이 이미 0 으로 만들어 두어 my 만 붙인다 */}
          <p className="my-[8px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray600 lg:my-0 lg:text-[20px] lg:leading-[160%] lg:tracking-[-0.4px]">
            {COMPANY_ADDRESS[currentLang]}
          </p>
          <p className="flex gap-[8px] font-medium leading-[140%] tracking-[-0.32px] text-apps-brandGray600 lg:gap-[12px] lg:text-[18px] lg:leading-[160%] lg:tracking-[-0.36px]">
            <span className="text-[18px] font-bold leading-[120%] tracking-[-0.36px] text-apps-brandPrimary600 lg:text-[20px] lg:leading-[140%] lg:tracking-[-0.4px]">
              T.{' '}
            </span>
            {phoneNumber}
          </p>
        </div>
        <AniSlideUp delay={0.3} distance={100}>
          {/* lg 의 width / margin-top 은 기본값과 같아 유틸리티를 중복으로 붙이지 않는다 */}
          <div className="mt-[24px] h-[300px] w-full overflow-hidden rounded-[20px] lg:h-[499px]">
            <CustomGoogleMap
              width="100%"
              height="100%"
              language={currentLang}
              location={{
                lat: DUMMY_MAP_DATA[0].add_data.address.lat,
                lng: DUMMY_MAP_DATA[0].add_data.address.lng,
              }}
              markerData={MarkerData}
              onMarkerClick={markerClickHandler}
            />
          </div>
        </AniSlideUp>
      </Area>
    </section>
  );
}
